module.exports = __webpack_public_path__ + "static/img/028.17e30775.jpg";